import React from 'react';

const Tooltip = ({ width, height, xshift, yshift, children, show }) => {
  return show ? (
    <g transform={`translate(${xshift},${yshift})`}>
      <foreignObject width={width} height={height}>
        {children}
      </foreignObject>
    </g>
  ) : null;
};

Tooltip.displayName = 'Tooltip';
export { Tooltip };
